import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss'
})
export class Sidebar implements OnInit {

  links = [
  {
    label: 'Dashboard',
    path: '/admin/dashboard',
    icon: '/images/sidebar/dashboard.svg',
    iconActive: '/images/sidebar/dashboard-active.svg',
    matchRoutes: ['/admin/dashboard']
  },
  {
    label: 'Fixigo Provider',
    path: '/admin/fixigo-provider',
    icon: '/images/sidebar/service-taker.svg',
    iconActive: '/images/sidebar/service-taker-active.svg',
    matchRoutes: ['/admin/fixigo-provider']
  },
  {
    label: 'Landlord Management',
    path: '/admin/owner-management',
    icon: '/images/sidebar/owners.svg',
    iconActive: '/images/sidebar/owners-active.svg',
    matchRoutes: [
      '/admin/owner-management',
      '/admin/property-details',
      '/admin/property/details'
    ]
  },
  {
    label: 'Tenant Management',
    path: '/admin/tenant-management',
    icon: '/images/sidebar/tenant.svg',
    iconActive: '/images/sidebar/tenant-active.svg',
    matchRoutes: [
      '/admin/tenant-management',
      '/admin/property-details',
      '/admin/property/details'
    ]
  },
  {
    label: 'Property Management',
    path: '/admin/property-management',
    icon: '/images/sidebar/property.svg',
    iconActive: '/images/sidebar/property-active.svg',
    matchRoutes: ['/admin/property-management']
  },
  {
    label: 'Communication',
    path: '/admin/communication',
    icon: '/images/sidebar/communication.svg',
    iconActive: '/images/sidebar/communication-active.svg',
    matchRoutes: ['/admin/communication']
  },
  {
    label: 'Payment Management',
    path: '/admin/payment-management',
    icon: '/images/sidebar/payment.svg',
    iconActive: '/images/sidebar/payment-active.svg',
    matchRoutes: ['/admin/payment-management']
  },
  {
    label: 'Disputes',
    path: '/admin/job-disputes',
    icon: '/images/sidebar/move-out.svg',
    iconActive: '/images/sidebar/move-out-active.svg',
    matchRoutes: [
      '/admin/job-disputes',
      '/admin/job-disputes/job-details'
    ]
  },
  {
    label: 'Referal & Rewards',
    path: '/admin/referal-rewards',
    icon: '/images/sidebar/rewards.svg',
    iconActive: '/images/sidebar/rewards-active.svg',
    matchRoutes: ['/admin/referal-rewards']
  },
  {
    label: 'Move out Management',
    path: '/admin/move-out-management',
    icon: '/images/sidebar/move-out.svg',
    iconActive: '/images/sidebar/move-out-active.svg',
    matchRoutes: [
      '/admin/move-out-management',
      '/admin/move-out-details',
      '/admin/property/details'
    ]
  }
];

  activeIndex = -1;
  beforeActiveIndex = -1;
  afterActiveIndex = -1;

  constructor(private router: Router,
    private snackbar: SnackbarService
  ) {}

  ngOnInit() {

    this.detectActiveTab();

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.detectActiveTab();
      });

  }

  detectActiveTab() {

  const url = this.router.url;
  const [baseUrl, queryString] = url.split('?');

  const params = new URLSearchParams(queryString || '');
  const userType = params.get('user');

  let idx = -1;

  idx = this.links.findIndex(link =>
    link.matchRoutes.some(route => baseUrl.startsWith(route))
  );

  if (baseUrl.startsWith('/admin/property-details') || baseUrl.startsWith('/admin/property/details')) {
    if (userType === 'owner') {
      idx = this.links.findIndex(l => l.path === '/admin/owner-management');
    }
    if (userType === 'tenant') {
      idx = this.links.findIndex(l => l.path === '/admin/tenant-management');
    }
    if (userType === 'moveout') {
      idx = this.links.findIndex(l => l.path === '/admin/move-out-management');
    }

  }

  if (idx > -1) {
    this.activeIndex = idx;
    this.beforeActiveIndex = idx - 1;
    this.afterActiveIndex = idx + 1;
  }

}

  logout() {
    localStorage.clear();
    localStorage.setItem('logout-event', Date.now().toString());
    this.router.navigate(['/auth/login']);
    this.snackbar.notify('Logged out successfully', 1);
  }

}